common.View.create('canvas.blocks.custom.headerVideo.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {

        this.element.find('.owl-carousel').owlCarousel({
            loop: this.element.find('.owl-carousel').children().length > 1,
            autoplay: this.element.find('.owl-carousel').data('autoplay'),
            margin: 5,
            nav: this.element.find('.owl-carousel').data('show-navigation'),
            dots: false,
            items: 1,
        });

    }
});
